import {
  forwardRef,
  omitThemingProps,
  useStyleConfig,
  chakra,
} from '@chakra-ui/system';
import type { HTMLChakraProps, ThemingProps } from '@chakra-ui/system';

export type MarkProps = ThemingProps<'Mark'> & HTMLChakraProps<'mark'>;

export const Mark = forwardRef<MarkProps, 'mark'>((props, ref) => {
  const styles = useStyleConfig('Mark', props);
  const ownProps = omitThemingProps(props);

  return <chakra.mark ref={ref} {...ownProps} __css={styles} />;
});
Mark.displayName = 'Mark';
